import React from "react";
import "./sendMailConfirmRegistration.scss";

import HeaderRegistration from "../registration/components/headerRegistration/HeaderRegistration";
import { Button, Stack } from "react-bootstrap";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { useScreenSize } from "../../ScreenSizeContext";
import { Trans } from "react-i18next";

const SendMailConfirmRegistration = () => {
  const navigate = useNavigate();
  const isPC = useScreenSize();

  const openGmail = () => {
    const isMobile = /android|iphone|ipad|ipod/i.test(navigator.userAgent);

    if (isMobile) {
      // Prova ad aprire l'app Gmail
      window.location.href = "googlegmail://";
      // Fallback dopo mezzo secondo a Gmail Web (nuova scheda)
      setTimeout(() => {
        window.open("https://mail.google.com", "_blank");
      }, 500);
    } else {
      // Desktop: apri Gmail Web in nuova scheda
      window.open("https://mail.google.com", "_blank");
    }
  };

  return (
    <div className="min-vh-100 w-100 d-flex justify-content-center align-items-center container-send-mail-confirm-registration">
      <Stack
        gap={3}
        className="confirm-registration d-flex justify-content-center align-items-center"
      >
        {/* Dopo la registrazione, qui si spiega come completare la conferma */}
        <HeaderRegistration
          title={t("send_mail_confirm_registration.title")}
          subtitle={
            <Trans
              i18nKey="send_mail_confirm_registration.subtitle"
              components={{ bold: <strong /> }}
            />
          }
        />
        <Button
          variant="light"
          size="md"
          onClick={openGmail}
          style={{ width: 310 }}
        >
          {t("send_mail_confirm_registration.button")}
        </Button>
        <a href="/login">{t("send_mail_confirm_registration.login")}</a>
      </Stack>
    </div>
  );
};

export default SendMailConfirmRegistration;
